import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
  AlertController,
  ViewController
} from "ionic-angular";
import * as papa from "papaparse";
import { DatabaseProvider } from '../../providers/database/database';
import * as _ from "lodash";
import { AuthProvider } from "../../providers/auth/auth";
import * as moment from 'moment';
import { UtilityProvider } from "../../providers/utility/utility";
import { PatientProvider } from "../../providers/patient/patient";

@IonicPage()
@Component({
  selector: "page-patient-upload",
  templateUrl: "patient-upload.html"
})
export class PatientUploadPage {
  user: any;
  uploadedPatients: Array<Object> = [];
  message: string = null;
  program_name: string = null;
  program_id: string = null;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    private readonly auth: AuthProvider,
    public database: DatabaseProvider,
    private viewCtrl: ViewController,
    private utility: UtilityProvider,
    private dbPatients: PatientProvider
  ) {

    this.auth.getCurrentUser().then(user => {
      this.user = { id: user.id, name: user.first_name + ' ' + user.last_name };
      this.program_name = user.program_name;
      this.program_id = user.program_id;
    });
  }

  parseCSV(files: FileList): void {
    let loading = this.loadingCtrl.create({
      content: "Uploading and checking patient info..."
    });

    loading.present().then(_ => {
      const file: File = files.item(0);
      const reader: FileReader = new FileReader();
      reader.readAsText(file);
      reader.onload = e => {
        const csv = reader.result;
        //const parsed = papa.parse(csv, {
        papa.parse(csv, {
          // dynamicTyping: true,
          header: true,
          complete: () => {
            console.log("Completed Data", this.uploadedPatients);
            loading.dismiss();
          },
          error: error => {
            console.error(error.message);
            loading.dismiss();
          },
          step: row => {
            // Add Fullname
            row.data[0]["full_name"] = row.data[0]["first_name"] + ' ' + row.data[0]["last_name"];

            if(row.data[0]['phone_number']) {
              row.data[0]['phone_number'] = this.utility.formate164(row.data[0]['phone_number']).replace('-','').replace('-','').replace('-','');
            }
            if(row.data[0]['work_phone_number']) {
              row.data[0]['work_phone_number'] = this.utility.formate164(row.data[0]['work_phone_number']).replace('-','').replace('-','').replace('-','');
            }
            
            // Fix 2 digit date problem
            if(row.data[0]["enrolment_received"])  {
              console.log("Original Enrolment: ", row.data[0]["enrolment_received"]);
              let datearray = row.data[0]["enrolment_received"].split("-");
              let day = datearray[2];
              let month = datearray[1];
              let year = datearray[0];
              if(year.length < 3) {
              if(parseInt("20" + year) <= parseInt((new Date()).getFullYear().toString())) {
                    year = "20" + year;
                  }
                  else {
                    year = "19" + year;
                  }
                }
                let newdatestring = year + '-' + month + '-' + day;
              
                console.log("New Enrolment: ", newdatestring);
                let newDOB = new Date(newdatestring)
                
                row.data[0]["enrolment_received"] = newDOB;
            }

           // Fix 2 digit date problem
           if(row.data[0]["dob"] || row.data[0]["dob"] !== '')  {
            console.log("Original dob: ", row.data[0]["dob"]);
            let datearray = row.data[0]["dob"].split("-");
            let day = datearray[0];
            let month = datearray[1];
            let year = datearray[2];
            if(year.length < 3) {
            if(parseInt("20" + year) <= parseInt((new Date()).getFullYear().toString())) {
                  year = "20" + year;
                }
                else {
                  year = "19" + year;
                }
              }
              let newdatestring = year + '-' + month + '-' + day;
            
              console.log("New dob: ", newdatestring);
              let newdate = new Date(newdatestring)
              
              row.data[0]["dob"] = newdate;
          }
          if(row.data[0]['address'] === '') row.data[0]['address'] = null;
          if(row.data[0]['address2'] === '') row.data[0]['address2'] = null;
          if(row.data[0]['address2_shipping'] === '') row.data[0]['address2_shipping'] = null;
          if(row.data[0]['address_shipping'] === '') row.data[0]['address_shipping'] = null;
          if(row.data[0]['alt_contact_cell_number'] === '') row.data[0]['alt_contact_cell_number'] = null;
          if(row.data[0]['alt_contact_consent'] === '') row.data[0]['alt_contact_consent'] = null;
          if(row.data[0]['alt_contact_desc'] === '') row.data[0]['alt_contact_desc'] = null;
          if(row.data[0]['alt_contact_email'] === '') row.data[0]['alt_contact_email'] = null;
          if(row.data[0]['alt_contact_name'] === '') row.data[0]['alt_contact_name'] = null;
          if(row.data[0]['alt_contact_phone_number'] === '') row.data[0]['alt_contact_phone_number'] = null;
          if(row.data[0]['alt_contact_phone_number'] === '') row.data[0]['alt_contact_phone_number'] = null;
          if(row.data[0]['city'] === '') row.data[0]['city'] = null;
          if(row.data[0]['city_shipping'] === '') row.data[0]['city_shipping'] = null;
          if(row.data[0]['clinic'] === '') row.data[0]['clinic'] = null;
          if(row.data[0]['commmercial_compassionate'] === '') row.data[0]['commmercial_compassionate'] = null;
          if(row.data[0]['diagnosis_date'] === '') row.data[0]['diagnosis_date'] = null;
          if(row.data[0]['dob'] === '') row.data[0]['dob'] = null;
          if(row.data[0]['doctor'] === '') row.data[0]['doctor'] = null;
          if(row.data[0]['dose'] === '') row.data[0]['dose'] = null;
          if(row.data[0]['email'] === '') row.data[0]['email'] = null;
          if(row.data[0]['enrolment_received'] === '') row.data[0]['enrolment_received'] = null;
          if(row.data[0]['first_name'] === '') row.data[0]['first_name'] = null;
          if(row.data[0]['last_name'] === '') row.data[0]['last_name'] = null;
          if(row.data[0]['gender'] === '') row.data[0]['gender'] = null;
          if(row.data[0]['healthcard'] === '') row.data[0]['healthcard'] = null;
          if(row.data[0]['height'] === '') row.data[0]['height'] = null;
          if(row.data[0]['indication'] === '') row.data[0]['indication'] = null;
          if(row.data[0]['language'] === '') row.data[0]['language'] = null;
          if(row.data[0]['middle_name'] === '') row.data[0]['middle_name'] = null;
          if(row.data[0]['ncm'] === '') row.data[0]['ncm'] = null;
          if(row.data[0]['notes'] === '') row.data[0]['notes'] = null;
          if(row.data[0]['phone_number'] === '') row.data[0]['phone_number'] = null;
          if(row.data[0]['postal_code'] === '') row.data[0]['postal_code'] = null;
          if(row.data[0]['postal_code_shipping'] === '') row.data[0]['postal_code_shipping'] = null;
          if(row.data[0]['province'] === '') row.data[0]['province'] = null;
          if(row.data[0]['province_shipping'] === '') row.data[0]['province_shipping'] = null;
          if(row.data[0]['program_patient_id'] === '') row.data[0]['program_patient_id'] = null;
          if(row.data[0]['rcm'] === '') row.data[0]['rcm'] = null;
          if(row.data[0]['status'] === '') row.data[0]['status'] = null;
          if(row.data[0]['substatus'] === '') row.data[0]['substatus'] = null;
          if(row.data[0]['therapy'] === '') {
            row.data[0]['therapy'] = null 
          } else { 
            row.data[0]['therapy'] = row.data[0]['therapy'].trim();
          }
          if(row.data[0]['voicemail_consent'] === '') row.data[0]['voicemail_consent'] = null;
          if(row.data[0]['weight'] === '') row.data[0]['weight'] = null;
          if(row.data[0]['work_number'] === '') row.data[0]['work_number'] = null;
          
          Object.keys(row.data[0]).forEach(key => {
            if (row.data[0][key] instanceof String)  {
              row.data[0][key] = row.data[0][key].toString().trim();
            } 
          });
        
            //row.data[0]["phone_number_primary"] = phone;
            //console.log("Phone Number: ", row.data[0]["phone_number"]);

            // update email address
   

            // push patient to array
             this.uploadedPatients.push(row.data[0]);
            //console.log(row.meta.cursor / csv.size * 100);
          }
        });
        //this.uploadedPatients = parsed.data;
        // do something with parsed CSV
      };
    });
  }

  completeUpload() {
    let confirm = this.alertCtrl.create({
      title: "Add Patients?",
      message:
        "Are you sure you would like to add " +
        this.uploadedPatients.length +
        " patients?",
      buttons: [
        {
          text: "No",
          handler: () => {
            console.log("Don't upload patients");
          }
        },
        {
          text: "Yes",
          handler: () => {
            _.forEach(this.uploadedPatients, async row => {
              console.log('Upload Started');
              await this.savePatient(row);
              console.log('Upload Finished');
            });
          }
        }
      ]
    });
    confirm.present();
  }

  async savePatient(row) {
    return new Promise(async (resolve, reject) => {
   //  console.log(this.program_id, row, 'Start FS Write', this.user);
    await this.dbPatients
      .addPatient(this.program_id, row, this.user, null)
      .then(response => {
        console.log("Write OK to FS", response);
        resolve(true);
      })
      .catch(err => {
        console.log("Write Error to FS", err);
        reject(false);
      });
    });
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/patient-upload/patient-upload.ts